import * as React from "react";
import Resume from "./components/resume/resume";
import { Route, Routes } from "react-router-dom";
import PageNotFound from "./components/PageNotFound";
import BlogList from "./components/BlogList/BlogList";
import FullBlogPost from "./components/FullBlogPost/FullBlogPost";
import { blogPosts } from "./components/Blogs/blogPosts";
import HomePage from "./components/HomePage/homepage";

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/resume" element={<Resume />} />
        <Route exact path="/blog" element={<BlogList posts={blogPosts} />} />
        <Route path="/blog/:id" element={<FullBlogPost posts={blogPosts} />} />
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default App;
